import { flowConfigMap } from "@/config/flowConfig";
import DesktopWarning from "@/pages/DesktopWarning/DesktopWarning.vue";
import Error from "@/pages/Error/Error.vue";
import HelpCentral from "@/pages/HelpCentral/HelpCentral.vue";
import HomeView from "@/pages/HomeView/HomeView.vue";
import Tutorial from "@/pages/Tutorial/Tutorial.vue";
import { useApiStore } from "@/stores/api";
import { useAppStore } from "@/stores/app";
import type { RouteRecordRaw } from "vue-router";
import router from ".";

export const appRoutes: RouteRecordRaw[] = [
  {
    name: "home",
    path: "/",
    component: HomeView,
    beforeEnter: (to) => {
      if (to.query.tag == null) {
        const store = useAppStore();
        store.setFlowConfig(flowConfigMap.bikeWithoutTag);
      }
    },
  },
  {
    path: "/:insuranceCode",
    name: "insurance",
    component: HomeView,
    props: true,
  },
  {
    name: "homeWithTag",
    path: "/:tag/:storeToken",
    component: HomeView,
    beforeEnter: () => {
      const store = useAppStore();
      store.setFlowConfig(flowConfigMap.bikeWithTag);
    },
  },
  {
    name: "error",
    path: "/error",
    component: Error,
  },
  {
    name: "desktop",
    path: "/desktop",
    component: DesktopWarning,
    meta: { isAllowedInDesktop: true },
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: Tutorial,
  },
  {
    name: "bikePossession",
    path: "/bike-possession",
    component: () => import("@/pages/BikePossession/BikePossession.vue"),
  },
  {
    name: "bikeModel",
    path: "/bike-model",
    component: () => import("@/pages/BikeModel/BikeModel.vue"),
  },
  {
    name: "bikeSerialNumber",
    path: "/bike-serial-number",
    component: () => import("@/pages/BikeSerialNumber/BikeSerialNumber.vue"),
  },
  {
    name: "termsOfService",
    path: "/terms-of-service",
    component: () => import("@/pages/TermsOfService/TermsOfService.vue"),
  },
  {
    name: "privacyPolicy",
    path: "/privacidade",
    component: () => import("@/pages/PrivacyPolicy/PrivacyPolicy.vue"),
    meta: { isAllowedInDesktop: true },
  },
  {
    name: "clientInfo",
    path: "/client-info",
    component: () => import("@/pages/Client/Client.vue"),
  },
  {
    name: "planSelection",
    path: "/plan-selection",
    component: () => import("@/pages/PlanSelection/PlanSelection.vue"),
  },
  {
    name: "planDetails",
    path: "/plan-details",
    component: () => import("@/pages/PlanDetails/PlanDetails.vue"),
  },
  {
    name: "clientCpf",
    path: "/client-cpf",
    component: () => import("@/pages/ClientCPF/ClientCPF.vue"),
  },
  {
    name: "ownershipWarning",
    path: "/ownership-warning",
    component: () => import("@/pages/OwnershipWarning/OwnershipWarning.vue"),
  },
  {
    name: "address",
    path: "/address",
    component: () => import("@/pages/BikeAddress/BikeAddress.vue"),
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("@/pages/Payment/Payment.vue"),
  },
  {
    name: "paymentMethod",
    path: "/payment-method",
    component: () => import("@/pages/PaymentMethod/PaymentMethod.vue"),
  },
  {
    name: "clientVerification",
    path: "/client-verification",
    component: () => import("@/pages/EmailVerification/EmailVerification.vue"),
  },
  {
    name: "bikeReceipt",
    path: "/bike-receipt/:dev?",
    component: () => import("@/pages/BikeReceipt/BikeReceipt.vue"),
  },
  {
    name: "selfie",
    path: "/selfie",
    component: () => import("@/pages/Selfie/Selfie.vue"),
  },
  {
    name: "photo",
    path: "/photo",
    component: () => import("@/pages/BikePhoto/BikePhoto.vue"),
  },
  {
    name: "selectBrand",
    path: "/select-brand",
    component: () => import("@/pages/SelectBrand/SelectBrand.vue"),
  },
  {
    name: "readTag",
    path: "/read-tag",
    component: () => import("@/pages/ReadTag/ReadTag.vue"),
  },
  {
    name: "bikeOrScooter",
    path: "/bike-or-scooter",
    component: () => import("@/pages/BikeOrScooter/BikeOrScooter.vue"),
  },
  {
    name: "video",
    path: "/video",
    component: () => import("@/pages/BikeVideo/BikeVideo.vue"),
  },
  {
    name: "help",
    path: "/help",
    component: HelpCentral,
  },
  {
    name: "end",
    path: "/end",
    component: () => import("@/pages/End/End.vue"),
    beforeEnter: async () => {
      const api = useApiStore();

      if (!api.isFinished) {
        const finishResult = await api.finish();
        if (finishResult) {
          api.setHasInsurance(api.tag);
        }
      }

      if (!api.isFinished) {
        router.replace({ name: "error" });
      }
    },
  },
  {
    name: "pendingPricing",
    path: "/pending-pricing",
    component: () => import("@/pages/PendingPricing/PendingPricing.vue"),
  },
  {
    name: "journeysInProgress",
    path: "/journeys-in-progress",
    component: () => import("@/pages/JourneysInProgress/JourneysInProgress.vue"),
  },
  {
    path: "/store/:storeToken",
    alias: "/s/:storeToken",
    name: "storeHome",
    component: HomeView,
    props: true,
  },
];
